// This file serves as a one stop for importing react-query functions
import * as reactQuery from "@tanstack/react-query-v5";

export const useMutation = reactQuery.useMutation;
export const useQuery = reactQuery.useQuery;
export const useQueryClient = reactQuery.useQueryClient;
export const QueryClient = reactQuery.QueryClient;
export const QueryClientProvider = reactQuery.QueryClientProvider;
